<div class="modal fade" id="kt_modal_add_user" tabindex="-1" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered mw-650px">
		<div class="modal-content">
			<div class="modal-header p-3 d-flex justify-content-between bg-secondary" id="kt_modal_add_user_header">
				<h2 class="fw-bold m-0">Add Agent</h2>
				<div class="btn btn-icon btn-sm btn-active-icon-primary" data-kt-users-modal-action="close">
					<i class="ki-duotone ki-cross fs-1">
						<span class="path1"></span>
						<span class="path2"></span>
					</i>
				</div>
			</div>
			<form id="kt_modal_add_user_form" class="form" [formGroup]="userForm" (ngSubmit)="onSubmit()"  novalidate>
				<div class="modal-body p-5">
					<div class="d-flex flex-column scroll-y p-3" id="kt_modal_add_user_scroll" data-kt-scroll="true" data-kt-scroll-activate="true" data-kt-scroll-max-height="auto" data-kt-scroll-dependencies="#kt_modal_add_user_header" data-kt-scroll-wrappers="#kt_modal_add_user_scroll" data-kt-scroll-offset="300px">
						<div class="fv-row mb-7">
							<label class="d-block fw-semibold fs-6 mb-5">Avatar</label>
							<style>
								.image-input-placeholder {
									background-image: url('assets/media/svg/files/blank-image.svg');
								}

								[data-bs-theme="dark"] .image-input-placeholder {
									background-image: url('assets/media/svg/files/blank-image-dark.svg');
								}
							</style>
							<div class="image-input image-input-outline image-input-placeholder" data-kt-image-input="true">
								<div class="image-input-wrapper w-125px h-125px" style="background-image: url(assets/media/avatars/300-6.jpg);"></div>
								<label class="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow" data-kt-image-input-action="change" data-bs-toggle="tooltip" title="Change avatar">
									<i class="ki-duotone ki-pencil fs-7">
										<span class="path1"></span>
										<span class="path2"></span>
									</i>
									<input type="file" name="avatar" accept=".png, .jpg, .jpeg" (change)="onImageSelected($event)" />
									<input type="hidden" name="avatar_remove" />
								</label>
								<span class="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow" data-kt-image-input-action="cancel" data-bs-toggle="tooltip" title="Cancel avatar">
									<i class="ki-duotone ki-cross fs-2">
										<span class="path1"></span>
										<span class="path2"></span>
									</i>
								</span>
								<span class="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow" data-kt-image-input-action="remove" data-bs-toggle="tooltip" title="Remove avatar" (click)="removeImage()">
									<i class="ki-duotone ki-cross fs-2">
										<span class="path1"></span>
										<span class="path2"></span>
									</i>
								</span>
							</div>
							<div class="form-text">Allowed file types: png, jpg, jpeg.</div>
							<div *ngIf="isImageUploading" class="d-flex align-items-center mt-3">
								<span class="spinner-border spinner-border-sm me-2"></span>
								<span class="text-muted">Uploading image...</span>
							</div>
							<div *ngIf="uploadedImageUrl && !isImageUploading" class="d-flex align-items-center mt-3">
								<i class="ki-duotone ki-check-circle fs-2 text-success me-2">
									<span class="path1"></span>
									<span class="path2"></span>
								</i>
								<span class="text-success">Image uploaded successfully</span>
							</div>
						</div>
						<div class="mb-5">
							<label for="name" class="form-label fs-7 fw-semibold mb-2">Name <span class="required"></span></label>
							<div class="form-group row">
								<div class="col-md-3">
									<select class="form-select form-select-sm" formControlName="title">
										<option value="Mr.">Mr.</option>
										<option value="Ms.">Ms.</option>
										<option value="Mrs.">Mrs.</option>
										<option value="Dr.">Dr.</option>
									</select>
								</div>
								<div class="col-md-9">
									<input type="text" formControlName="name" id="name" class="form-control form-control-sm" placeholder="Full Name"
										[class.is-invalid]="userForm.get('name')?.invalid && userForm.get('name')?.touched" />
									<div class="invalid-feedback" *ngIf="userForm.get('name')?.invalid && userForm.get('name')?.touched">
										<div *ngIf="userForm.get('name')?.errors?.['required']">Name is required</div>
									</div>
								</div>
							</div>
						</div>
						<div class="fv-row row">
							<div class="col-md-6 mb-5">
								<label for="prefix" class="form-label fs-7 fw-semibold mb-2">User Prefix</label>
								<input type="text" formControlName="prefix" id="prefix" class="form-control form-control-sm" />
							</div>
							<div class="col-md-6 mb-5">
								<label for="login_id" class="form-label fs-7 fw-semibold mb-2">Login ID <span class="required"></span></label>
								<input type="text" formControlName="login_id" id="login_id" class="form-control form-control-sm"
									[class.is-invalid]="userForm.get('login_id')?.invalid && userForm.get('login_id')?.touched" />
								<div class="invalid-feedback" *ngIf="userForm.get('login_id')?.invalid && userForm.get('login_id')?.touched">
									<div *ngIf="userForm.get('login_id')?.errors?.['required']">Login ID is required</div>
								</div>
							</div>
						</div>
						<div class="fv-row row">
							<div class="col-md-6 mb-5">
								<label for="password" class="form-label fs-7 fw-semibold mb-2">Password <span class="required"></span></label>
								<input type="password" formControlName="password" id="password" class="form-control form-control-sm"
									[class.is-invalid]="userForm.get('password')?.invalid && userForm.get('password')?.touched" />
								<div class="invalid-feedback" *ngIf="userForm.get('password')?.invalid && userForm.get('password')?.touched">
									<div *ngIf="userForm.get('password')?.errors?.['required']">Password is required</div>
									<div *ngIf="userForm.get('password')?.errors?.['minlength']">Password must be at least 6 characters</div>
								</div>
							</div>
							<div class="col-md-6 mb-5">
								<label for="confirm_password" class="form-label fs-7 fw-semibold mb-2">Confirm Password</label>
								<input type="password" formControlName="confirm_password" id="confirm_password" class="form-control form-control-sm"
									[class.is-invalid]="userForm.get('confirm_password')?.invalid && userForm.get('confirm_password')?.touched" />
								<div class="invalid-feedback" *ngIf="userForm.get('confirm_password')?.invalid && userForm.get('confirm_password')?.touched">
									<div *ngIf="userForm.get('confirm_password')?.errors?.['required']">Confirm Password is required</div>
									<div *ngIf="userForm.get('confirm_password')?.errors?.['passwordMismatch']">Passwords do not match</div>
								</div>
							</div>
						</div>
						<div class="fv-row row">
							<div class="col-md-6 col-sm-12 mb-5">
								<label for="email" class="form-label fs-7 fw-semibold mb-2">Email <span class="required"></span></label>
								<input type="email" formControlName="email" id="email" class="form-control form-control-sm" placeholder="example@domain.com"
									[class.is-invalid]="userForm.get('email')?.invalid && userForm.get('email')?.touched" />
								<div class="invalid-feedback" *ngIf="userForm.get('email')?.invalid && userForm.get('email')?.touched">
									<div *ngIf="userForm.get('email')?.errors?.['required']">Email is required</div>
									<div *ngIf="userForm.get('email')?.errors?.['email']">Please enter a valid email</div>
								</div>
							</div>
							<div class="col-md-6 col-sm-12 mb-5">
								<label for="phone" class="form-label fs-7 fw-semibold mb-2">Phone <span class="required"></span></label>
								<input type="tel" formControlName="phone" id="phone" class="form-control form-control-sm"
									[class.is-invalid]="userForm.get('phone')?.invalid && userForm.get('phone')?.touched" />
								<div class="invalid-feedback" *ngIf="userForm.get('phone')?.invalid && userForm.get('phone')?.touched">
									<div *ngIf="userForm.get('phone')?.errors?.['required']">Phone is required</div>
								</div>
							</div>
						</div>
						<div class="fv-row row">
							<div class="col-md-6 col-sm-12 mb-5">
								<label for="email_2" class="form-label fs-7 fw-semibold mb-2">Email 2</label>
								<input type="email" formControlName="email_2" id="email_2" class="form-control form-control-sm" placeholder="example@domain.com"
									[class.is-invalid]="userForm.get('email_2')?.invalid && userForm.get('email_2')?.touched" />
								<div class="invalid-feedback" *ngIf="userForm.get('email_2')?.invalid && userForm.get('email_2')?.touched">
									<div *ngIf="userForm.get('email_2')?.errors?.['email']">Please enter a valid email</div>
								</div>
							</div>
							<div class="col-md-6 col-sm-12 mb-5">
								<label for="phone_2" class="form-label fs-7 fw-semibold mb-2">Phone 2</label>
								<input type="tel" formControlName="phone_2" id="phone_2" class="form-control form-control-sm" />
							</div>
						</div>
						<div class="fv-row row">
							<div class="col-md-6 col-sm-12 mb-5">
								<label for="mobile" class="form-label fs-7 fw-semibold mb-2">Mobile</label>
								<input type="tel" formControlName="mobile" id="mobile" class="form-control form-control-sm" />
							</div>
							<div class="col-md-6 col-sm-12 mb-5">
								<label for="fax" class="form-label fs-7 fw-semibold mb-2">Fax</label>
								<input type="tel" formControlName="fax" id="fax" class="form-control form-control-sm" />
							</div>
						</div>
						<div class="fv-row row">
							<div class="col-md-6 col-sm-12 mb-5">
								<label for="country" class="form-label fs-7 fw-semibold mb-2">Country</label>
								<select class="form-select h-40px fs-7" formControlName="country" id="country">
									<option value="" selected disabled>Select Country</option>
									<option *ngFor="let country of countryList" [value]="country.code">{{ country.name }}</option>
								</select>
							</div>
						</div>
						<div class="fv-row row">
							<div class="col-sm-12 mb-5">
								<label for="address" class="form-label fs-7 fw-semibold mb-2">Address</label>
								<textarea formControlName="address" id="address" class="form-control form-control-sm"></textarea>
							</div>
						</div>
						<div class="fv-row row">
							<div class="col-md-4 col-sm-12 mb-5">
								<label for="city" class="form-label fs-7 fw-semibold mb-2">City</label>
								<input type="text" formControlName="city" id="city" class="form-control form-control-sm" />
							</div>
							<div class="col-md-4 col-sm-12 mb-5">
								<label for="state" class="form-label fs-7 fw-semibold mb-2">State</label>
								<input type="text" formControlName="state" id="state" class="form-control form-control-sm" />
							</div>
							<div class="col-md-4 col-sm-12 mb-5">
								<label for="zip" class="form-label fs-7 fw-semibold mb-2">Zip</label>
								<input type="text" formControlName="zip" id="zip" class="form-control form-control-sm" />
							</div>
						</div>
						<div class="fv-row row">
							<div class="col-md-6 mb-5">
								<label for="designation" class="form-label fs-7 fw-semibold mb-2 required">Designation</label>
								<select class="form-select form-select-sm" formControlName="designation" id="designation"
									[class.is-invalid]="userForm.get('designation')?.invalid && userForm.get('designation')?.touched">
									<option value="" selected disabled>Select</option>
									<option value="Super Admin">Super Admin</option>
									<option value="Admin">Admin</option>
									<option value="Supervisor">Supervisor</option>
									<option value="Manager">Manager</option>
									<option value="Assistant">Assistant</option>
								</select>
								<div class="invalid-feedback" *ngIf="userForm.get('designation')?.invalid && userForm.get('designation')?.touched">
									<div *ngIf="userForm.get('designation')?.errors?.['required']">Designation is required</div>
								</div>
							</div>
							<div class="col-md-6 mb-5">
								<label for="status" class="form-label fs-7 fw-semibold mb-2 required">Status</label>
								<div class="d-flex gap-4 h-35px">
									<div class="form-check form-check-sm form-check-custom form-check-solid">
										<input type="radio" class="form-check-input" value="blocked" formControlName="status" id="statusBlocked" />
										<label class="form-check-label" for="statusBlocked">Blocked</label>
									</div>
									<div class="form-check form-check-sm form-check-custom form-check-solid">
										<input type="radio" class="form-check-input" value="permitted" formControlName="status" id="statusPermitted" />
										<label class="form-check-label" for="statusPermitted">Permitted</label>
									</div>
								</div>
								<div class="invalid-feedback d-block" *ngIf="userForm.get('status')?.invalid && userForm.get('status')?.touched">
									<div *ngIf="userForm.get('status')?.errors?.['required']">Status is required</div>
								</div>
							</div>
						</div>
						<div class="fv-row row">
							<div class="col-md-6 mb-5">
								<label for="is_primary_agent" class="form-label fs-7 fw-semibold mb-2 required">Primary Agent</label>
								<div class="d-flex gap-4 h-35px">
									<div class="form-check form-check-sm form-check-custom form-check-solid">
										<input type="radio" class="form-check-input" value="yes" formControlName="is_primary_agent" id="primaryAgentYes" />
										<label class="form-check-label" for="primaryAgentYes">Yes</label>
									</div>
									<div class="form-check form-check-sm form-check-custom form-check-solid">
										<input type="radio" class="form-check-input" value="no" formControlName="is_primary_agent" id="primaryAgentNo" />
										<label class="form-check-label" for="primaryAgentNo">No</label>
									</div>
								</div>
								<div class="invalid-feedback d-block" *ngIf="userForm.get('is_primary_agent')?.invalid && userForm.get('is_primary_agent')?.touched">
									<div *ngIf="userForm.get('is_primary_agent')?.errors?.['required']">Primary Agent selection is required</div>
								</div>
							</div>
							<div class="col-md-6 mb-5" *ngIf="userForm.get('is_primary_agent')?.value === 'no'">
								<label for="primary_agent" class="form-label fs-7 fw-semibold mb-2 required">Select Primary Agent</label>
								<app-searchable-select
									[options]="primaryAgentOptions"
									placeholder="Select Primary Agent"
									formControlName="primary_agent"
									size="sm"
									[clearable]="false"
									[class.is-invalid]="userForm.get('primary_agent')?.invalid && userForm.get('primary_agent')?.touched">
								</app-searchable-select>
								<div class="invalid-feedback" *ngIf="userForm.get('primary_agent')?.invalid && userForm.get('primary_agent')?.touched">
									<div *ngIf="userForm.get('primary_agent')?.errors?.['required']">Primary Agent selection is required</div>
								</div>
							</div>
						</div>
						<div class="fv-row row">
							<div class="col-md-6 mb-5">
								<label for="company_agent_id" class="form-label fs-7 fw-semibold mb-2">Company Agent</label>
								<app-searchable-select
									[options]="companyAgentOptions"
									placeholder="Select Company Agent"
									formControlName="company_agent_id"
									size="sm"
									[clearable]="true"
									[class.is-invalid]="userForm.get('company_agent_id')?.invalid && userForm.get('company_agent_id')?.touched">
								</app-searchable-select>
								<div class="invalid-feedback" *ngIf="userForm.get('company_agent_id')?.invalid && userForm.get('company_agent_id')?.touched">
									<div *ngIf="userForm.get('company_agent_id')?.errors?.['required']">Company Agent selection is required</div>
								</div>
							</div>
						</div>
						<div class="mb-5">
							<label class="required fw-semibold fs-7 mb-2">Role</label>
							<div *ngFor="let role of rolesList; let i = index">
								<div class="d-flex fv-row">
									<div class="form-check form-check-custom form-check-sm form-check-solid">
										<input class="form-check-input me-3" formControlName="role" type="radio" [value]="role._id" [id]="'kt_modal_update_role_option_' + i" />
										<label class="form-check-label" [for]="'kt_modal_update_role_option_' + i">
											<div class="fw-bold text-gray-800">{{ role.name }}</div>
											<div class="text-gray-600">{{ role.description || 'Role for ' + role.name }}</div>
										</label>
									</div>
								</div>
								<div class='separator separator-dashed my-3' *ngIf="i < rolesList.length - 1"></div>
							</div>
							<div class="invalid-feedback d-block" *ngIf="userForm.get('role')?.invalid && userForm.get('role')?.touched">
								<div *ngIf="userForm.get('role')?.errors?.['required']">Role is required</div>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer px-5 d-flex justify-content-between">
					<button type="submit" class="btn btn-sm btn-primary" [disabled]="isLoading"
						[attr.data-kt-indicator]="isLoading ? 'on' : null">
						<span class="indicator-label" *ngIf="!isLoading">Submit</span>
						<span class="indicator-progress" *ngIf="isLoading">Please wait...
							<span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
					</button>
					<button type="button" class="btn btn-sm btn-dark" (click)="resetForm()" [disabled]="isLoading">Discard</button>
				</div>
			</form>
		</div>
	</div>
</div>
